import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Segment } from '@app/models';
import { BaseServiceClass } from '../baseService.service';

@Injectable({ providedIn: 'root' })
export class SegmentServiceV3 extends BaseServiceClass<Segment> {
  constructor(protected httpService: HttpClient) {
    super(httpService, '/api/v3/segments');
  }
}
